import React from "react";
import { BreadcrumbItem, Container } from "reactstrap";
import * as AgentKeys from "@repoflow/components/agent-keys";
import * as KeysQL from "queries/key";

// "Connect an agent": mint a key for an AI agent — Claude Code, Cursor, any MCP
// client that can send a header — to keep this food log through noshchat's MCP
// server, show how to connect it, and list and revoke the agent keys.
// docs/noshchat.md §Agents and MCP.
//
// The panel is @repoflow/components/agent-keys, shared with pagews. Every key
// minted here is `roles: ["agent"]` bound to this organization's food log —
// the server sets the binding, so the panel gets no scope and the mint sends
// only who it is for. It reaches the chat, entries, the target, the cupboard,
// settings and the statistics, and none of the API keys, and it authenticates
// nowhere but noshchat. Auth limits it to 60 requests a minute and 5,000 a day.

export const SERVICE = "noshchat";

export const mcpUrlOf = AgentKeys.mcpUrlOf;

export const connectionOf = (origin, keyId, keySecret) => AgentKeys.connectionOf(SERVICE, origin, keyId, keySecret);

const queries = { agents: KeysQL.agents, mint: KeysQL.createAgent, remove: KeysQL.remove };

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>Agents</BreadcrumbItem>;

export const Content = () => (
  <Container className="mt-4" style={{ maxWidth: 900 }}>
    <h4 className="m-0">Agents</h4>
    <AgentKeys.Panel
      service={SERVICE}
      queries={queries}
      mintField={"createAgent"}
      update={KeysQL.update}
      title={"Agent keys"}
      keysScreen={"API Keys"}
    >
      <p>
        An agent key lets an AI agent keep this food log for you: log what you ate, correct or remove entries,
        set your daily target, keep the cupboard, choose which meals show, and read the dashboard. It cannot see
        or make API keys.
      </p>
    </AgentKeys.Panel>
  </Container>
);
